export default {
    instanceManage: {
        page: {
            TransactionInstance: 'Transaction Instance',
            Status: 'Status',
            businessType: 'Associated Business Type',
            businessID: 'Associated Business ID',
            Done: 'Completed',
            Failed: 'Failed',
            InProgress: 'In Progress',
            WaitingPulled: 'Awaiting to be pulled',
        },
        table: {
            TransactionInstance: 'Transaction Instance',
            TransactionDescription: 'Transaction Description',
            Status: 'Status',
            ProgressBar: 'Progress Bar',
            StartTime: 'Start Time',
            businessType: 'Associated Business Type',
            businessID: 'Associated Business ID',
        },
    },
};
